<template>
  <div class="ma-4 px-4">
    <searchBar :addField="false" @updateSearch="(v) => (search = v)" />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="StudentElectiveProgramHeaders"
            :search="search"
            :items="items"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                class="mr-2"
                color="accent"
                @click="navigateToStudentElectives(item)"
              >
                mdi-dots-horizontal
              </v-icon>
            </template>

            <template #[`item.program_batch_id`]="{ item }">
              {{ getProgramBatchName(item.program_batch_id) }}
            </template>
            <template #[`item.partner_id`]="{ item }">
              {{ getPartnerName(item.partner_id) }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import searchBar from "@/components/searchBar.vue";
import { StudentElectiveProgramHeaders } from "@/constants/headers";

export default {
  components: {
    searchBar,
  },
  data() {
    return {
      items: [],
      search: "",
      StudentElectiveProgramHeaders,
      programBatches: [],
      partners: [],
    };
  },
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Elective" }]);
    this.initialise();
  },
  methods: {
    initialise() {
      this.getProgramBatches();
      this.getPartners();
      this.studentElectiveProgram();
    },
    async getProgramBatches() {
      await this.$axios.get("/program_batches").then((res) => {
        this.programBatches = res.data.data;
      });
    },
    async getPartners() {
      await this.$axios.get("/partners").then((res) => {
        this.partners = res.data.data;
      });
    },
    getProgramBatchName(id) {
      const programBatch = this.programBatches.find((p) => p.id == id);
      return programBatch ? programBatch.name : "";
    },
    getPartnerName(id) {
      const partner = this.partners.find((p) => p.id === id);
      return partner ? partner.name : "";
    },
    async studentElectiveProgram() {
      await this.$axios
        .get("/get_student_electives")
        .then(async (res) => {
          const allItems = res.data.data;
          const configuredPartnerIds = await this.getConfiguredPartnerIds();
          this.items = configuredPartnerIds
            ? allItems.filter((item) =>
                configuredPartnerIds.includes(item.partner_id),
              )
            : allItems;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response?.data?.message || "Failed to fetch",
            color: "error",
          });
        });
    },
    async getConfiguredPartnerIds() {
      try {
        const res = await this.$axios.get("/list_elective_configs_for_admin");
        return [
          ...new Set(
            res.data.data
              .filter((config) => config.config_id != null)
              .map((config) => config.partner_id),
          ),
        ];
      } catch (error) {
        // On failure, fall back to showing all rows rather than a blank table.
        return null;
      }
    },
    navigateToStudentElectives(item) {
      this.$router.push({
        path: "/student_elective_course",
        query: {
          program_batch_id: item.program_batch_id,
          partner_id: item.partner_id,
        },
      });
    },
    customFilter(value, search, item) {
      if (!search) return true;

      const programName = this.getPartnerName(item.partner_id);
      const programBatchName = this.getProgramBatchName(item.program_batch_id);

      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        programName.toLowerCase().includes(search.toLowerCase()) ||
        programBatchName.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
